import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Input } from 'wt-ui';
import { useDebouncedCallback } from 'use-debounce';

import i18next from '../../translations/i18n';
import { actions } from '../../services/reducer';

const strContainsParts = (str, parts) => {
  let hasAll = true;
  parts.forEach((x) => {
    if (str.indexOf(x) < 0) {
      hasAll = false;
      return false;
    }
    return true;
  });
  return hasAll;
};
const fundListToSuggestions = (fundList, match = '') => {
  if (match === '') {
    return fundList.map((x) => ({ key: x.bloombergTickerPrimary || x.bloombergTicker, value: `${x.productName}` }));
  }

  const parts = match.toLowerCase().split(' '); 
  // filter by indiduals words - order not mandatory
  return fundList
    .filter((x) => strContainsParts(`${x.productName} ${x.bloombergTickerPrimary || x.bloombergTicker}`.toLowerCase(), parts))
    .map((x) => ({ key: x.bloombergTickerPrimary || x.bloombergTicker, value: `${x.productName}` }));
};

const AutocompleteInput = ({ fundList, dispatch }) => {
  const [suggestions, setSuggestions] = useState(fundListToSuggestions(fundList));
  const [value, setValue] = useState('');

  const [getSuggestionsDebounced] = useDebouncedCallback(
    async (typedValue) => {
      const newSuggestions = fundListToSuggestions(fundList, typedValue);
      setSuggestions(newSuggestions);
    },
    500,
    [],
  );

  const onChange = (event) => {
    setValue(event.target.value);
    getSuggestionsDebounced(event.target.value);
  };
  const onSelect = (event) => {
    setValue(event.value);
    dispatch({
      type: actions.setTicker,
      value: fundList.find((x) => (x.bloombergTickerPrimary || x.bloombergTicker) === event.key),
    });
  };

  return (
    <Input
      value={value}
      placeholder={`${i18next.t('Search for a product')}`}
      suggestions={suggestions}
      onChange={onChange}
      onSelect={onSelect}
      onEnter={onSelect}
      maxHeight="400px"
    />
  );
};

AutocompleteInput.propTypes = {
  fundList: PropTypes.arrayOf(PropTypes.object).isRequired,
  dispatch: PropTypes.func.isRequired,
};

const SearchInput = ({ ...props }) => (
  <Box background="transparent" width="medium">
    <AutocompleteInput {...props} />
  </Box>
);

export default SearchInput;
